import script from "./pricingtoggleswitch.vue?vue&type=script&setup=true&lang=js"
export * from "./pricingtoggleswitch.vue?vue&type=script&setup=true&lang=js"

import "./pricingtoggleswitch.vue?vue&type=style&index=0&id=66bbbdae&scoped=true&lang=css"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66bbbdae"]])

export default __exports__